/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
function t(t, n) {
  var s = t.x - n.x,
      r = t.y - n.y,
      a = t.hasZ && n.hasZ ? t.z - n.z : 0;
  return Math.sqrt(s * s + r * r + a * a);
}

function n(t, n) {
  var s = t.x - n.x,
      r = t.y - n.y,
      a = t.hasZ && n.hasZ ? t.z - n.z : 0;
  return s * s + r * r + a * a;
}

export { t as distance, n as squareDistance };